import { ChangeEvent, FC, startTransition, useEffect, useState } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useDebounceCallback } from 'usehooks-ts';

import { Input } from 'components/Form/Input';

export type Props = {
  filter?: string;
  onFilterChange: (filter: string) => void;
  placeholder: string;
  className?: string;
};

export const SearchInput: FC<Props> = ({ filter = '', onFilterChange, placeholder, className }) => {
  const [filterValue, setFilterValue] = useState(filter);
  const debouncedOnFilterChange = useDebounceCallback(onFilterChange, 200);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setFilterValue(newValue);
    startTransition(() => {
      debouncedOnFilterChange(newValue);
    });
  };

  /**
   * Reset the filter when the filter value changes.
   * We need to do this because we are debouncing the calls directly from this component instead of the parent
   */
  useEffect(() => {
    if (filter === '') {
      setFilterValue(filter);
    }
  }, [filter]);

  return (
    <Input
      placeholder={placeholder}
      leftIcon={<MagnifyingGlassIcon className="size-4 text-gray-400" />}
      type="text"
      value={filterValue}
      onChange={handleChange}
      className={className}
    />
  );
};
